import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import ChevronLeftIcon from '@ad-scripts/presentation/components/common/icons/stroke/chevron-left-stroke';

const BackButton = ({
  'data-aid': dataAid,
  className,
  label,
  backUrl,
}: {
  className?: string;
  label: string;
  backUrl: string;
  'data-aid'?: string;
}) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(backUrl);
  };

  return (
    <StyledButton data-aid={dataAid} type={ButtonTypes.TEXT} className={className} onClick={handleClick}>
      <StyledChevronLeftIcon />
      {label}
    </StyledButton>
  );
};

const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
  fill: ${p => p.theme.colors.gray700};
  margin: 0 8px 0 0;
  position: relative;
  top: 1px;
  width: 13px;
`;

const StyledButton = styled(Button)`
  text-align: left;
  padding: 0 0 24px 0;
  color: ${p => p.theme.colors.gray700};

  &:hover {
    color: ${p => p.theme.colors.green400};

    ${StyledChevronLeftIcon} {
      fill: ${p => p.theme.colors.green400};
    }
  }
`;

export default BackButton;
